import React from "react";
import IndividualCampaign from "./IndividualCampaign";
import { useParams } from "react-router-dom";

const IndividualCampaigns = () => {
  const { id } = useParams();

  console.log(id);
  return (
    <IndividualCampaign
      campaignId={id}
      onBack={() => {
        window.history.back();
      }}
    />
  );
};

export default IndividualCampaigns;
